// Die Reihenfolge der Standardliste fürs Material (seit dem Augentest E3b,
// Gernot, 23.10.2026: „je nachdem, wie man sie einträgt …, stehen dann nicht
// schön untereinander“) – eine Regel für das Büro (Seite „Standardmaterial“)
// und die Doku-App (Kacheln und Varianten einer Gruppe):
//
//  - zuerst nach Gruppe – ein Eintrag ohne Gruppe steht dort, wo seine
//    Bezeichnung hinfällt (so stehen „Kabelkanal 40×40“ ohne Gruppe und die
//    Gruppe „Kabelkanal“ beieinander),
//  - dann nach Bezeichnung,
//  - Zahlen der Reihe nach („40×40“ vor „60×60“ vor „100×100“), Groß- und
//    Kleinschreibung und Akzente zählen nicht.
//
// Kein eigenes Feld für die Reihenfolge: Ziehen und Ablegen bräuchte eine
// neue Spalte in der Datenbank (PROJEKT.md, O87).

/** Was die Reihenfolge braucht – die Gruppe ist freiwillig. */
export interface StandardOrdnungsEintrag {
  id: string;
  bezeichnung: string;
  gruppe?: string | null;
}

const VERGLEICH = new Intl.Collator("de-AT", { numeric: true, sensitivity: "base" });

/** Vergleicht zwei Einträge der Standardliste – für `sort`. Bei Gleichstand entscheidet die Kennung, damit die Reihenfolge fest ist. */
export function standardVergleich(a: StandardOrdnungsEintrag, b: StandardOrdnungsEintrag): number {
  const sa = a.gruppe?.trim() || a.bezeichnung;
  const sb = b.gruppe?.trim() || b.bezeichnung;
  return VERGLEICH.compare(sa, sb) || VERGLEICH.compare(a.bezeichnung, b.bezeichnung) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
}

/** Die Liste in dieser Reihenfolge – eine neue Liste, die alte bleibt, wie sie ist. */
export function standardOrdnen<T extends StandardOrdnungsEintrag>(liste: readonly T[]): T[] {
  return [...liste].sort(standardVergleich);
}
